<script>
import { get, debounce } from "lodash";

export default {
  mounted() {
    Vue.nextTick(this.comunicateIframeSize);
    window.addEventListener("resize", debounce(this.comunicateIframeSize, 200));
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.comunicateIframeSize);
  },
  methods: {
    applyContextToUrl: Fandom.applyContextToUrl,
    getTarget: Fandom.getTarget,
    comunicateIframeSize() {
      parent.postMessage({ message: "iframe-size", height: this.$el.clientHeight, width: this.$el.clientWidth }, "*");
    }
  },
  computed: {
    content() {
      return get(globalState, ["pageModel", "name_to_content", "embeddable-footer"], {});
    },
    mainLink() {
      return get(this, ["content", "site"], false);
    },
    links() {
      const data = get(this, ["content", "links"], []);
      return data.filter(item => Fandom.exists(item.url)).map(item => item.url);
    },
    logo() {
      return get(this, ["content", "logo"], false);
    }
  }
};
</script>

<template>
  <footer class="w-100 px-0 px-md-2 py-3 py-md-0 bg-dark">
    <div class="container-fluid">
      <div class="row d-flex align-items-center main-row">
        <div class="col-12 col-md-auto pr-md-0">
          <a
            class="d-block d-lg-inline-block mb-3 mb-md-0 font-weight-bold text-uppercase main-link mr-3"
            v-if="mainLink"
            :href="applyContextToUrl(mainLink.url)" :target="getTarget(mainLink)"
            >
            {{mainLink.title}}
          </a>
        </div>
        <div class="col-auto d-none d-md-block">
          <div class="nav-separator"></div>
        </div>
        <div class="col-12 col-md-auto d-flex flex-column flex-md-row">
          <a
            class="d-block d-lg-inline-block mb-2 mb-md-0 mr-md-4 text-uppercase link"
            v-for="(item, index) in links" :key="index"
            :href="applyContextToUrl(item.url)" :target="getTarget(item)" :title="item.title"
            >
            {{item.title}}
          </a>
        </div>
        <div class="col-12 col-md mr-0 d-flex align-items-md-center justify-content-end" v-if="logo">
          <a
            class="link"
            :href="applyContextToUrl(logo.url.url)" :target="getTarget(logo.url)" v-if="logo.url"
            >
            <img
              :src="logo.icon.url" v-if="logo.icon"
              alt="logo.url.title"
              class="logo"
              />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.main-row {
  min-height: 5rem;
}

.main-link {
  color: $white;
  font-size: 0.75rem;
  width: 4rem;
}

.nav-separator {
  width: 1px;
  background-color: darken($white, 25%);
  height: 2.5rem;
}

.link {
  color: darken($white, 25%);
  transition: color $animation-time-medium;
  font-size: 0.75rem;

  @include hover {
    color: $white;
  }
}

.logo {
  height: 3rem;
}

@include media-breakpoint-down(sm) {
  
  .main-link {
    width: 100%;

    &:after {
      display: none;
    }
  }
}
</style>
